import MobileDetect from 'mobile-detect';
const md = new MobileDetect(navigator.userAgent);

export const isMobile = md.mobile() || md.tablet();
export const isIphone = md.is('iPhone');
export const isSafari = md.userAgent() === 'Safari';